import { ComponentProps } from 'react'

import BadRequestIcon from '@/assets/svg/BadRequestIcon.svg'
import { getContainerHeight } from '@/components/entities/requests/model/utils'

const HEADER_HEIGHT = 120

const DrawerError = ({ style }: ComponentProps<'div'>) => {
  return (
    <div
      className="flex w-full flex-col items-center justify-center gap-32"
      style={{ height: getContainerHeight(HEADER_HEIGHT), ...style }}
    >
      <BadRequestIcon className="h-[240px] w-[240px] xxs:h-[180px] xxs:w-[180px]" />
      <p className="text-center text-grey-90 text-24 xs:text-20 xxs:text-18">
        Попробуйте зайти позже или перезагрузите страницу
      </p>
    </div>
  )
}

export default DrawerError
